import React, { useState, useEffect, useRef } from "react";
//Service
import {getComplaintByCode, setDenunciaComment, ChangePassword, sePuedeCambiarPassword, setDocumento} from '../../services/denunciaService';
import axios from 'axios';
//Form
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
//Utils
import * as notification from "../../utils/notification";
import { COMPLAINT_STATE, ComplaintStatesOptions } from "../../utils/constants";
import * as Errors from "../../utils/errors";
//Controls
import { Row, Col, Button, Modal, ModalBody, Badge} from "reactstrap";
import { Link } from 'react-router-dom';
//Components
import Input from "../common/Input";
import ComplaintComments from "../common/ComplaintComments";
import ErrorMessage from "../../components/common/ErrorMessage";
//Icons
import { FiRotateCcw, FiX } from "react-icons/fi";
import { BiArrowToBottom } from "react-icons/bi";

const CommentSchema = Yup.object().shape({
  comment: Yup.string().required(Errors.REQUIRED),
});
const PasswordSchema = Yup.object().shape({
  password: Yup.string().required(Errors.REQUIRED),
  Newpassword: Yup.string().min(12, 'Debe de tener 12 caracteres').required(Errors.REQUIRED),
});

const Buscar = ({}) => {
  const [code, setCode] = useState();
  const [password, setPassword] = useState();
  const [complaint, setComplaint] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showModalPass, setShowModalPass] = useState(false);
  const [showButtonPass, setShowButtonPass] = useState(false);
  const [boolPassword, setBoolPassword] = useState(false);
  const fileRef1 = useRef();
  const [file, setFile] = useState({});
  const [archivo, setArchivo] = useState(null);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (code && password){
     getComplaint(code, password);
     setShowButtonPass(true);
    }
    else setComplaint(showModalPass, showModalPass);
  }, [code, password]);

  const getComplaint = async (code, password) => {
    const result = await getComplaintByCode(code, password);
    const boolPassword = await sePuedeCambiarPassword(code, password);
    if(result.id != 0 && !boolPassword){ 
      setShowModalPass(true);
    }
    setComplaint(result);
  };
  const handleSubmit = (data) => {
    setCode(data.code);
    setPassword(data.password);
  };

  const handleSubmitComment = async (data) => {
    const response = await setDenunciaComment(
      code,
      data.comment,
      false
    );
    if (response && response.success) {
      notification.success(complaint.code, "Comentario enviado correctamente");
      getComplaint(code, password);
      toggleModal();
    }
  };
  const handleSubmitPass = async (data) => {
    const response = await ChangePassword(
      code,
      data.password,
      data.Newpassword
    );
    if (response && response.success) {
      notification.success(complaint.code, "Contraseña cambiada correctamente");
      setPassword(data.Newpassword);
      toggleModalPass();
    }
  };
  const handleDocumento = async (file) => {
    const formData = new FormData();
    formData.append("code", file.code);
    formData.append("documento", file.documento);
    
    try {
      await axios({
          method: 'post',
          url: "form/documento",
          data: formData,
      }).then(({ data }) => {
    if (data.success) {
      notification.success(complaint.code, "Se ha guardado el documento correctamente");
      getComplaint(code,password);
    }
  })
  } catch (error) {
      notification.error("", error.message || "Problemas en la llamada al servidor");
  }
  };
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const toggleModalPass =() => {
    setShowModalPass(!showModalPass);
    setBoolPassword(true);
  };
  return (
    <div>
    <div className="contenedor-main mt-0">
    <div className="mb-5">                               
        <p className='denuncia__title'>Consulta Denuncia/Consulta</p>
        <div>
        <Formik
            initialValues={{ 
              code: '', 
              password: ''
            }} 
            validationSchema={Yup.object().shape({
              code: Yup.string().required('Requerido'),
              password: Yup.string().required('Requerido'),
            })}
            onSubmit={handleSubmit}
            >
             {
              formik => (
              <Form className="w-100">
                <Row>
                  <Col xs="12" md="4">
                    <Field name='code' type='text' component={Input} placeholder='Código de denuncia o consulta*' className="form__input"/>
                    <ErrorMessage name='code' component='span' />
                  </Col>
                  <Col xs="12" md="4">
                    <Field name='password' type='password' component={Input} placeholder='Contraseña de denuncia o consulta*' className="form__input"/>
                    <ErrorMessage name='password' component='span' />
                  </Col>
                  <Col>
                    <Button
                      color="primary"
                      className="btn-primary d-inline-block mx-3"
                      type="submit"
                    >
                      Buscar
                    </Button>
                  </Col>
                  <Col md="11">
                  {showButtonPass && (                
                   <Button
                      color="primary"
                      className="btn-primary-coment"
                      onClick={toggleModalPass}
                    >
                      Cambiar contraseña
                    </Button>  
                 )} 
                 </Col>
                  <Col md="1">
                  <div><Link to={`/`}><Button color="primary" className="btn-primary-volver">Volver</Button></Link></div></Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
    </div>
   
    </div>
    
        {complaint && complaint.id == 0 && (
          <div className="contenedor-main mt-0">
          <div className="mb-5">  
            <div className="py-4">
              <p>
                Lo sentimos, la denuncia con código <strong>{code}</strong> no
                ha sido encontrada
              </p>
            </div>
          </div>
          </div>
        )}      
        {complaint && complaint.id > 0 && (
          <>
        <div className="contenedor-main mt-0">
        <div className="mb-5">  
          <Row>
          <Col xs="6" md="4" className="py-2">
            <p className='denuncia__title'>Datos de la consulta</p>
          </Col>
          </Row>
          <Row>        
          <Col xs="12" md="7">
          <Row>
          <Col xs="12" className="py-2">
              <Badge color="primary" className="font-weight-normal" pill>
                {
                  ComplaintStatesOptions.find(
                    (f) => f.value == complaint.tramiteEstadoId
                  ).label
                }
              </Badge>
            </Col>
            <Col xs="6" md="4" className="py-2">
              <p className='denuncia_campos'>Nombre y Apellidos</p>
              <label className="form__checkbox-label">{complaint.nombre || "-"}</label>
            </Col>
            <Col xs="6" md="4" className="py-2">
              <p className='denuncia_campos'>Móvil</p>
              <label className="form__checkbox-label">{complaint.telefono || "-"}</label>
            </Col>
            <Col xs="6" md="4" className="py-2">
              <p className='denuncia_campos'>Correo</p>
              <label className="form__checkbox-label">{complaint.email || "-"}</label>
            </Col>
            <Col xs="12">
              <p className='denuncia_campos'>Descripción</p>
              <label className="form__checkbox-label">{complaint.descripcionDenuncia ? complaint.descripcionDenuncia :  "-" 
              || complaint.descripcionConsulta ? complaint.descripcionConsulta :  "-"}</label>
            </Col>
            {complaint.tramiteEstadoId == 1 || complaint.tramiteEstadoId == 2 ? (
            <Col xs="12" className="mt-4">
            <p className='denuncia_campos'>Agregar documento</p>         
                <input
                  ref={fileRef1}
                  className="form__input_adjunto mb-3"
                  name="documento" type='file'
                  placeholder='Adjuntar archivo (pdf, word, jpg…)'
                  onChange={(e) => {
                   setFile(
                    {
                      code: complaint.code,
                      documento: e.target.files[0]
                    })}}
              />
              <ErrorMessage name="documento" component="span" />
              <Button
                    color="primary"
                    className="btn-primary-adjunto"  
                    onClick={() =>handleDocumento(file)}
                  >
                    Subir documento
              </Button>
            </Col>
            ):("")}
            <Col xs="12" className="mt-4">
            <p className='denuncia_campos'>Documentos</p>         
            {
                complaint.documento && 
                <Row>
                <Col  md="6">
                  <label className="form__checkbox-label">Documento principal</label></Col>
                  <Col  md="2"><a href={`${complaint.documento}`}
                  target="_blank" className="btn btn-primary btn-primary-adjunto">Descargar
                  </a></Col>
                </Row>
            }
            {complaint.documentos &&
                complaint.documentos.map((doc) => {
                return (
                  <Row>
                  <Col  md="6">
                  <label className="form__checkbox-label">{doc.name ? doc.name : "Documento"}</label></Col>
                  <Col  md="2"><a href={`${doc.documento}`}
                  target="_blank" className="btn btn-primary btn-primary-adjunto">Descargar
                  </a></Col>
                  </Row>
              );
            })
            }
            </Col>
          </Row>
          </Col>
        <Col xs="12" md="5" className="complaint-comments">
          <p className='denuncia__title'>Comentarios</p>
          <ComplaintComments comments={complaint.comentarios} fromManager={false} />
        </Col>
          </Row>
          <Row className="pb-4 border-bottom">
                <Col xs="12" className="text-right">
                  <Button
                    color="primary"
                    className="btn-primary"
                    disabled={[
                      COMPLAINT_STATE.Closed,
                      COMPLAINT_STATE.Removed,
                    ].includes(complaint.tramiteEstadoId)}
                    onClick={toggleModal}
                  >
                    Añadir un comentario
                  </Button>
                </Col>
          </Row>
        </div>
        </div>
        </>
      )}
      {showModal && (
        <Modal isOpen toggle={toggleModal} autoFocus={false} size="md">
          <div className="modal-header align-items-center">
            <div className="text-title-modal">{code}</div>
            <Button
              color="close"
              className="text-right p-0"
              onClick={toggleModal}
            >
              <FiX size={25} />
            </Button>
          </div>
          <ModalBody>
            <Formik
              initialValues={{}}
              enableReinitialize
              validationSchema={CommentSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={handleSubmitComment}
              render={() => (
                <Form className="w-100">
                  <Row>
                    <Col xs="12">
                      <Field
                        placeholder="Comentario*"
                        id="txtComment"
                        name="comment"
                        component={Input}
                        type="textarea"
                        rows="3"
                        autoComplete="off"
                      ></Field>
                      <ErrorMessage name='comment' component='span' />
                    </Col>
                    <Col xs="12" className="text-right">
                      <Button
                        color="primary"
                        className="rounded-pill"
                        type="submit"
                      >
                        Enviar comentario
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            />
          </ModalBody>
        </Modal>
      )}
    {showModalPass && (
      <Modal isOpen toggle={toggleModalPass} autoFocus={true} size="md">
      <div className="modal-header align-items-center">
        <div className="text-title-modal">{code}</div>
        <Button
          color="close"
          className="text-right p-0"
          onClick={toggleModalPass}
        >
          <FiX size={25} />
        </Button>
      </div>
      <ModalBody>
        <Formik
          initialValues={{
            password:'',
            Newpassword:''
          }}
          enableReinitialize
          validationSchema={PasswordSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={handleSubmitPass}
          render={() => (
            <Form className="w-100">
              <Row>
                        <Col xs="12">
                        <Field name='password' type='text' component={Input} placeholder='Contraseña Antigua*' className="form__input"/>
                        <ErrorMessage name='password' component='span' />
                        </Col>
                        <Col xs="12">
                        <Field name='Newpassword' type='text' component={Input} placeholder='Nueva Contraseña*' className="form__input"/>
                        <ErrorMessage name='Newpassword' component='span' />
                        </Col>
                        {!boolPassword && (
                          <Col>
                            <p className='denuncia_campos'>Es necesario cambiar la contraseña provisional</p>
                          </Col>
                        )}
                        <Col xs="12" className="text-right">
                          <Button
                            color="primary"
                            className="rounded-pill"
                            type="submit"
                          >
                            Cambiar
                          </Button>
                        </Col>
                      </Row>
            </Form>
          )}
        />
      </ModalBody>
    </Modal>
        )}
    </div>
  );
};
export default Buscar
